import { pillars } from '../data/homepage';

/**
 * RSMC brand pillars data
 * The four pillars spell out the RSMC acronym:
 * Ready, Secure, Managed, Cloud
 *
 * The copy is edited through the CMS (src/content/homepage.json → pillars);
 * this module only re-exports it under the name components already import.
 */

/**
 * @typedef {Object} RsmcPillar
 * @property {string} title - Pillar title (first letter forms the RSMC acronym)
 * @property {string} description - Pillar description
 */

/**
 * Array of RSMC brand pillars, displayed under the hero and above the
 * Solutions & Services section
 * @type {RsmcPillar[]}
 */
export const RSMC_PILLARS = pillars;
